const hasWindow = () => typeof window !== "undefined";

function cleanPayload(payload = {}) {
  return Object.entries(payload).reduce((cleaned, [key, value]) => {
    if (value === undefined || value === null || value === "") return cleaned;
    cleaned[key] = value;
    return cleaned;
  }, {});
}

function devWarn(message, error) {
  if (process.env.NODE_ENV === "development") {
    console.warn(message, error);
  }
}

function positiveNumber(value) {
  const number = Number(value);
  return Number.isFinite(number) && number > 0 ? number : undefined;
}

function normalizeCurrency(currency) {
  const code = String(currency || "")
    .trim()
    .toUpperCase();

  return /^[A-Z]{3}$/.test(code) ? code : undefined;
}

export function currencyValuePayload({ value, currency } = {}) {
  const validValue = positiveNumber(value);
  const validCurrency = normalizeCurrency(currency);

  if (!validValue || !validCurrency) return {};

  return {
    currency: validCurrency,
    value: validValue,
  };
}

export function pushDataLayer(event, payload = {}) {
  if (!hasWindow() || !event) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    ...cleanPayload(payload),
  });
}

export function trackFacebookEvent(event, payload = {}, method = "track") {
  if (!hasWindow() || typeof window.fbq !== "function" || !event) return;

  try {
    window.fbq(method, event, cleanPayload(payload));
  } catch (error) {
    devWarn(`Failed to send Meta Pixel event: ${event}`, error);
  }
}

export function trackEvent({
  event,
  payload = {},
  facebookEvent,
  facebookMethod = "track",
}) {
  const cleanedPayload = cleanPayload(payload);

  pushDataLayer(event, cleanedPayload);

  if (facebookEvent) {
    trackFacebookEvent(facebookEvent, cleanedPayload, facebookMethod);
  }
}

export function trackPageView({ sendFacebook = false } = {}) {
  if (!hasWindow()) return;

  const payload = {
    page_path: window.location.pathname + window.location.search,
    page_location: window.location.href,
    page_title: document.title,
  };

  pushDataLayer("page_view", payload);

  if (sendFacebook) {
    trackFacebookEvent("PageView", payload);
  }
}

export function programPayload(program = {}, id) {
  const slotPrices = Array.isArray(program?.slots)
    ? program.slots.map((slot) => positiveNumber(slot?.price)).filter(Boolean)
    : [];
  const price = positiveNumber(program?.price) || Math.min(...slotPrices);
  const name = program?.name || program?.title;
  const commercePayload = currencyValuePayload({
    value: price,
    currency: program?.currency,
  });
  const itemPayload = cleanPayload({
    item_id: id || program?._id,
    item_name: name,
    item_category: "Programs",
    price: positiveNumber(price),
    currency: commercePayload.currency,
  });

  return cleanPayload({
    content_name: name,
    content_id: id || program?._id,
    content_category: "Programs",
    ...commercePayload,
    item_id: id || program?._id,
    item_name: name,
    item_category: "Programs",
    price: positiveNumber(price),
    items: [itemPayload],
  });
}
